module.exports = __webpack_public_path__ + "static/media/delete.4a5fc2e4.svg";